let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("giNlE")).then(() => parcelRequire('9HReW'));